import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from './Modal';
import useActivityMonitor from '../hooks/useActivityMonitor';
import { disconnectSessions } from '../actions/session';

export const ExtendSessionDlg = ({
  handleDisconnectSessions,
}) => {
  const activityMonitor = useActivityMonitor();

  const open = activityMonitor.isIdle;

  const continueSession = () => {
    activityMonitor.extendActivity();
  };

  const endSessions = () => {
    handleDisconnectSessions();
  };

  return (
    <Modal isOpen={open} onRequestClose={continueSession}>
      <div tracking-module="extend-session">
        <div className="card card--action">
          <div className="mb24">
            <h2 className="mb6">Your session is about to end.</h2>
            <p className="body2 mb0">
              {`As a measure of added security, you'll be automatically
            redirected to My Account Overview in 60 seconds.`}
            </p>
          </div>
          <div className="action action--centered">
            <div className="action__item">
              <button
                type="button"
                className="button button--primary"
                onClick={continueSession}
              >
                Continue Session
              </button>
            </div>
            <div className="action__item">
              <button
                type="button"
                className="button"
                onClick={endSessions}
              >
                End Session
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapActionsToProps = dispatch => bindActionCreators({
  handleDisconnectSessions: disconnectSessions,
}, dispatch);

export default connect(null, mapActionsToProps)(ExtendSessionDlg);
